import { render, staticRenderFns } from "./brandProposal.vue?vue&type=template&id=60ba560f&scoped=true&"
import script from "./brandProposal.vue?vue&type=script&lang=js&"
export * from "./brandProposal.vue?vue&type=script&lang=js&"
import style0 from "./brandProposal.vue?vue&type=style&index=0&id=60ba560f&scoped=true&lang=css&"
import style1 from "./brandProposal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba560f",
  null
  
)

export default component.exports